import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import immer from 'immer';
import createReactContext from '../context';
import { Component } from '../component';
import { errorSubscribe, RESET_TOPIC } from '../Datum/types';
import { getGrid } from '../Grid/utils';
import { objectValues } from '../utils/objects';
import { formClass } from './styles';

var _createReactContext = createReactContext({}),
    Provider = _createReactContext.Provider,
    Consumer = _createReactContext.Consumer;

var Label =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Label, _PureComponent);

  var _super = _createSuper2(Label);

  function Label() {
    _classCallCheck(this, Label);

    return _super.apply(this, arguments);
  }

  _createClass(Label, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          children = _this$props.children;
      if (children === undefined) return null;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: {
            width: width
          },
          className: formClass('label')
        }, children)
      );
    }
  }]);

  return Label;
}(PureComponent);

// eslint-disable-next-line
var Item =
/*#__PURE__*/
function (_Component) {
  _inherits(Item, _Component);

  var _super2 = _createSuper2(Item);

  function Item(props) {
    var _this;

    _classCallCheck(this, Item);

    _this = _super2.call(this, props);
    _this.events = void 0;
    _this.updateTimer = void 0;
    _this.state = {
      inputs: {},
      errors: {}
    };
    _this.events = {
      bindInputToItem: _this.bind.bind(_assertThisInitialized(_this)),
      unbindInputFromItem: _this.unbind.bind(_assertThisInitialized(_this)),
      onItemError: _this.handleError.bind(_assertThisInitialized(_this))
    };
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
    if (props.formDatum) props.formDatum.subscribe(RESET_TOPIC, _this.handleUpdate);
    return _this;
  }

  _createClass(Item, [{
    key: "getErrors",
    value: function getErrors() {
      var formDatum = this.props.formDatum;
      var errors = [];

      if (formDatum) {
        Object.keys(this.state.inputs).forEach(function (name) {
          var err = formDatum.getError(name);
          if (err) errors.push(err);
        });
      }

      objectValues(this.state.errors).forEach(function (err) {
        if (err) errors.push(err);
      });
      return errors;
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      var _this2 = this;

      if (this.updateTimer) clearTimeout(this.updateTimer);
      this.updateTimer = setTimeout(function () {
        _this2.forceUpdate();
      });
    }
  }, {
    key: "bind",
    value: function bind(name) {
      var _this3 = this;

      var names = Array.isArray(name) ? name : [name];
      var formDatum = this.props.formDatum;

      if (formDatum) {
        names.forEach(function (n) {
          formDatum.subscribe(errorSubscribe(n), _this3.handleUpdate);
        });
      }

      this.setState(immer(function (state) {
        names.forEach(function (n) {
          state.inputs[n] = true;
        });
      }));
    }
  }, {
    key: "unbind",
    value: function unbind(name) {
      var names = Array.isArray(name) ? name : [name];
      var formDatum = this.props.formDatum;

      if (formDatum) {
        names.forEach(function (n) {
          formDatum.unsubscribe(errorSubscribe(n));
        });
      }

      this.setState(immer(function (state) {
        names.forEach(function (n) {
          delete state.inputs[n];
        });
      }));
    }
  }, {
    key: "handleError",
    value: function handleError(name, error) {
      this.setState(immer(function (state) {
        state.errors[name] = error;
      }));
    }
  }, {
    key: "renderHelp",
    value: function renderHelp(errors) {
      var realErrors = errors.filter(function (e) {
        return e.message;
      });

      if (realErrors.length > 0) {
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: formClass('error')
          }, realErrors.map(function (e, i) {
            return (
              /*#__PURE__*/
              React.createElement("div", {
                key: i
              }, e.message)
            );
          }))
        );
      }

      var tip = this.props.tip;
      if (!tip) return null;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: formClass('tip')
        }, tip)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          grid = _this$props2.grid,
          label = _this$props2.label,
          labelAlign = _this$props2.labelAlign,
          labelVerticalAlign = _this$props2.labelVerticalAlign,
          labelWidth = _this$props2.labelWidth,
          required = _this$props2.required,
          style = _this$props2.style,
          keepErrorHeight = _this$props2.keepErrorHeight;
      var errors = this.getErrors();
      var className = classnames(getGrid(grid), formClass('item', required && 'required', errors.length > 0 && 'invalid', labelVerticalAlign && "label-vertical-align-".concat(labelVerticalAlign), keepErrorHeight && "item-keep-height", ['top', 'right', 'left'].indexOf(labelAlign || '') >= 0 && "label-align-".concat(labelAlign)), this.props.className);
      return (
        /*#__PURE__*/
        React.createElement(Provider, {
          value: this.events
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: style
        },
        /*#__PURE__*/
        React.createElement(Label, {
          width: labelWidth
        }, label),
        /*#__PURE__*/
        React.createElement("div", {
          className: formClass('control')
        }, children, this.renderHelp(errors))))
      );
    }
  }]);

  return Item;
}(Component);

Item.defaultProps = {
  className: '',
  style: {},
  formItemErrors: [],
  keepErrorHeight: false
};
export default Item; // eslint-disable-next-line

export var itemConsumer = function itemConsumer(Origin) {
  return function (props) {
    return (
      /*#__PURE__*/
      React.createElement(Consumer, null, function (events) {
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, events))
        );
      })
    );
  };
};